import { Stack } from 'expo-router';
import { CartProvider as MinimalCartProvider } from 'features/cart/cart-provider';
import { useCartRecoveryMode } from 'features/cart/hooks/use-cart-recovery-mode';

import { PendingSubmittedOrderRecovery } from 'components/pending-submitted-order-recovery';
import { useGetCartGestureEnabledExperiment } from 'experiments/use-disable-cart-back-gesture';
import { usePendingSubmittedOrderCheckoutRoute } from 'hooks/use-pending-submitted-order-checkout-route';
import { CartProvider } from 'state/cart';

export const unstable_settings = {
  initialRouteName: 'cart/index',
};

export default function CartLayout() {
  const gestureEnabled = useGetCartGestureEnabledExperiment();
  const checkoutRoute = usePendingSubmittedOrderCheckoutRoute();
  const { mode } = useCartRecoveryMode();

  if (mode === 'minimal') {
    return (
      <MinimalCartProvider>
        <PendingSubmittedOrderRecovery checkoutRoute={checkoutRoute} />
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: 'transparent' },
            gestureEnabled,
          }}
        >
          <Stack.Screen name="cart/index" />
        </Stack>
      </MinimalCartProvider>
    );
  }

  return (
    <CartProvider>
      <PendingSubmittedOrderRecovery checkoutRoute={checkoutRoute} />
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: 'transparent' },
          gestureEnabled,
        }}
      >
        <Stack.Screen name="cart/index" />
        <Stack.Screen name="cart/payment/index" />
        <Stack.Screen
          name="cart/extras"
          options={{ presentation: 'modal', animation: 'slide_from_bottom', gestureEnabled: true }}
        />
      </Stack>
    </CartProvider>
  );
}
